import { z } from 'zod'

import { rateSchema } from 'shared/api/requests/aiConversationFeedback/schemas'

export const AiConversationFeedbackSchemasNew = {
  save: {
    request: rateSchema,
    response: z.unknown(),
    query: z
      .object({
        client_id: z.string().optional(),
      })
      .optional(),
    path: z.undefined(),
  },
  retrieve: {
    response: z.object({
      data: z.record(z.string(), rateSchema).nullable(),
    }),
    query: z.object({
      session_ids: z.array(z.string()),
    }),
    path: z.undefined(),
  },
}

export type AiConversationRate = z.infer<typeof rateSchema>
